import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { LuCookie, LuX } from 'react-icons/lu';

const STORAGE_KEY = 'cookie-consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 260, damping: 28 }}
          className="fixed bottom-4 left-4 right-4 z-[9999] flex justify-center pointer-events-none"
        >
          <div className="pointer-events-auto w-full max-w-2xl bg-slate-900/95 backdrop-blur-xl border border-slate-700/70 rounded-2xl shadow-2xl shadow-black/50 px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <div className="mt-0.5 shrink-0 w-8 h-8 rounded-xl bg-primary-500/15 flex items-center justify-center">
                <LuCookie size={16} className="text-primary-400" />
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">
                Usamos cookies propias para el funcionamiento de la plataforma. Consulta nuestra{' '}
                <Link to="/privacy" className="text-primary-400 hover:text-primary-300 underline transition">
                  Política de Privacidad
                </Link>
                .
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
              <button
                onClick={reject}
                className="flex-1 sm:flex-none px-4 py-2 text-xs font-semibold text-slate-400 hover:text-slate-200 border border-slate-700 hover:border-slate-600 rounded-xl transition"
              >
                Rechazar
              </button>
              <button
                onClick={accept}
                className="flex-1 sm:flex-none px-4 py-2 text-xs font-semibold bg-primary-500 hover:bg-primary-400 text-white rounded-xl transition shadow-lg shadow-primary-500/30"
              >
                Aceptar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
